/* globals console */
/* jshint loopfunc: true, curly: false, freeze: false, esnext: true */
(function($) {
	'use strict';
	$.fn.Collection__Sort_Manual = function() {
		this.each(function() { 
			
			var $self = $(this),
				$triggers = $self.find('.sort-slide-trigger');
			
			$triggers.on( $.Globals.clickEvent, function(e) {
				e.preventDefault();
				
				var $this 			= $(this),
					$draggables 	= $self.find('[draggable]'),
					$slide			= $this.closest('[draggable]'),
					direction 		= $this.data('sort');
					
					
				// Don't do anything if first and moving up or last and moving down
				if( ( $slide.is( $draggables.first() ) && direction === 'previous' ) || 
					( $slide.is( $draggables.last() ) && direction === 'next' ) ) {
					return;
				}
				
				
				// Okay, we can continue;
				var collection_id 	= $this.data('cid'),
					slide_id 		= $this.data('sid');
			
				// Do it
				if( collection_id !== undefined && slide_id !== undefined && direction !== undefined ) {
					
					$.Globals.ajax( 'scspaces_move_slide_in_collection', { cid: collection_id, sid: slide_id, dir: direction }, function( data ) {
						
						// On success
						if( ! data.success ) {
							console.warn( 'Error 918: Manual sort ajax error.');
						}
						
					});
					

					// Assume success for better UE
					if( direction === 'previous' ) {

						$slide.parent().children().eq( $slide.index() - 1 ).before( $slide );
			
					}else{
			
						// Move el down
						$slide.parent().children().eq( $slide.index()+1 ).after( $slide );
			
					}
				
				}
				
			});
			
		});
		return this;
	};
}(jQuery));